<template>
    <div v-if="options != null && selectable != null">
        <input type="hidden" :name="name + '[]'" :value="v" v-for="v in options.value(selectable)" />
        <Error v-if="!hideError" :error="error" class="mt-0 mb-4" :errorScrollTo="errorScrollTo" />

        <div class="flex flex-wrap gap-3">
            <label
                v-for="(option, oi) in selectable"
                class="px-4 h-10 flex items-center cursor-pointer relative h-10 border"
                :class="[options.selected(option) ? 'border-green-600 bg-green-600 bg-opacity-003' : 'border-grey-500']"
                @click="options.toggle(option)"
            >
                <p class="font-bold text-13">{{ option.name }}</p>
            </label>
        </div>
    </div>
</template>

<script>
import input from '~/mixins/input.js'

export default {
    props: {
        selectable: { default: null, type: Array },
        options: { default: null, type: Object },
    },

    mixins: [input],

    methods: {
        getValue() {
            return this.options.value(this.selectable)
        }
    }
}
</script>
